export default {
  GroupWebsiteEditorPageReorder: {
    mounted() {
      window.groupWebsiteEditorPageReorder = this;

      // Item currently being dragged
      this.draggedItem = {};

      // When clicked, show loading spinner
      this.el.querySelector('button.button[type=submit]').addEventListener('click', (e) => {
        const btn = e.target.closest('.button');

        // Give immediate feedback to user while we wait for a server response
        btn.classList.add('is-loading');

        const pagesInOrder = Array.from(
          this.el.querySelector('.panel').querySelectorAll('.page-dropzone'),
        ).map((page) => page.id.replace('page-', ''));

        // Send event to server
        this.pushEvent(
          'reorder',
          {
            pagesInOrder,
          },
          // eslint-disable-next-line no-unused-vars
          (reply, ref) => {
            if (reply && 'status' in reply) {
              btn.classList.remove('is-loading');
            }
          },
        );
      });
    },

    dragstart(event) {
      event.dataTransfer.setData('text/plain', event.target.id);
      this.draggedItem = event.target;
    },

    dragenter(event) {
      event.preventDefault();
    },

    dragover(event) {
      event.preventDefault();

      if (event.target) {
        const dropzone = event.target.closest('.page-dropzone');

        // Highlight dropzone
        dropzone.classList.add('on-dragover');

        const dropzonePosition = [...Array.from(dropzone.parentNode.children)].indexOf(dropzone);
        const draggedItemPosition = [...Array.from(dropzone.parentNode.children)].indexOf(
          this.draggedItem,
        );

        // Confirm dropzone's position is not the same as the draggedItem's position
        // Otherwise we'll keep switching the two over and over
        if (dropzonePosition !== draggedItemPosition) {
          // If the dropzone's position is more than the draggedItem's position
          // Insert the draggedItem before it, i.e. dropzone is moved before it
          if (dropzonePosition > draggedItemPosition) {
            dropzone.insertAdjacentElement('afterend', this.draggedItem);
          }
          // If the dropzone's position is less than the draggedItem's position
          // Insert the draggedItem after it, i.e. dropzone is pushed after it
          if (dropzonePosition < draggedItemPosition) {
            dropzone.insertAdjacentElement('beforebegin', this.draggedItem);
          }
        }
      }
    },

    dragleave(event) {
      // Remove highlight from dropzone
      if (event.target) {
        event.target.closest('.page-dropzone').classList.remove('on-dragover');
      }
    },

    dragend(event) {
      event.preventDefault();

      // Remove highlight from all droppable zones
      document.querySelectorAll('.page-dropzone').forEach((el) => {
        el.classList.remove('on-dragover');
      });

      // Clear out item being currently dragged
      this.draggedItem = {};
    },

    drop(event) {
      event.preventDefault();
    },
  },
};
